export default "__VITE_ASSET__D9Mmkgnf__"